
import { useQuasar } from 'quasar';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import { auth } from 'boot/firebase';
import { Unsubscribe } from '@firebase/util';
import {
  matMenu,
  matChatBubbleOutline,
  matCategory,
  matHelp,
  matLogin,
  matLogout,
  matCloudDone,
  matContactSupport,
} from '@quasar/extras/material-icons';

export default {
  name: 'MainLayout',
  setup() {
    const $q = useQuasar();
    const router = useRouter();
    const currentUser = ref(auth.currentUser);
    const leftDrawerOpen = ref(false);

    function toggleLeftDrawer() {
      leftDrawerOpen.value = !leftDrawerOpen.value;
    }

    async function onLogout() {
      await auth.signOut();

      $q.notify({
        color: 'green-9',
        textColor: 'white',
        icon: matCloudDone,
        message: 'Logged out',
      });

      await router.push('/login');
    }

    let removeAuthObserver: Unsubscribe;
    onMounted(() => {
      removeAuthObserver = auth.onAuthStateChanged((user) => {
        currentUser.value = user;
      });
    });

    onBeforeUnmount(() => {
      removeAuthObserver();
    });

    return {
      currentUser,
      leftDrawerOpen,
      toggleLeftDrawer,
      onLogout,
      matMenu,
      matChatBubbleOutline,
      matCategory,
      matHelp,
      matLogin,
      matLogout,
      matContactSupport,
    };
  },
};
